import { Header } from '@/components/header/Header';
import { useAuthStore } from '@/stores/AuthStore';
import { useMemo } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

/**
 * Layout para rotas protegidas.
 * Redireciona o usuário para "/login" se ele não estiver autenticado.
 */
const ProtectedLayout = () => {
  const { getUser, getToken } = useAuthStore();

  const tokens = useMemo(() => getToken(), []);
  const user = useMemo(() => getUser(), []);

  if (!user || !tokens) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      {/* Aqui pode ser adicionado um cabeçalho ou menu comum às rotas protegidas */}
      <Header />
      <Outlet />
    </div>
  );
};

export default ProtectedLayout;
